import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { BBReferralLegType } from 'src/domains/sportsbook/betting/betSlipState/BetSlipTypes';
import { BetSlipBBReferralState } from 'src/domains/sportsbook/betting/ui/betSlip/betslipBBReferral/BetSlipBBReferralState';
import {
    ChevronIconWrapper,
    BetslipYouDecideEventReturn,
    BetslipYouDecideLabel,
    BetslipYouDecideLabelEvent,
    BetslipYouDecideRabItemsWrapper,
    BetslipYouDecideReturn,
    BetslipYouDecideWrapper,
    RabItems,
    RabItemsWrapper,
    RabItemsWrapperMarket,
    RabItemsWrapperOdds,
    RabItemsWrapperSelection,
    ReturnWrapper,
} from 'src/domains/sportsbook/betting/ui/betSlip/BetslipShared.style';
import { useCommon } from 'src/domains/common/Common';

interface PropsType {
    bbBet: BBReferralLegType;
}

export const BetslipBBReferral = observer('BetslipBBReferral', ({ bbBet }: PropsType) => {
    const common = useCommon();

    const [bbBetState] = React.useState(new BetSlipBBReferralState(bbBet, common));
    const { title, eventName, selections, priceLabel, stakeDisplay, potentialReturnsLabel } = bbBetState;

    return (
        <BetslipYouDecideWrapper
            className='BetslipBBReferral'
            data-test='betslip-bb-referral-section'
        >
            <BetslipYouDecideLabel
                onClick={bbBetState.toggleVisibility}
                data-test='betslip-bb-referral-header'
            >
                <ChevronIconWrapper position={bbBetState.isVisible ? 'down' : 'right'} />
                {title}
            </BetslipYouDecideLabel>

            <BetslipYouDecideRabItemsWrapper>
                {typeof eventName === 'string' ? (
                    <BetslipYouDecideLabelEvent data-test='event-name'>{eventName}</BetslipYouDecideLabelEvent>
                ) : null}
                <RabItems>
                    {selections.map((selection) => {
                        const { selectionName, marketName } = selection;

                        return (
                            <RabItemsWrapper>
                                <RabItemsWrapperSelection data-test='bb-referral-name'>
                                    {selectionName}
                                </RabItemsWrapperSelection>
                                <RabItemsWrapperMarket data-test='bb-referral-market'>
                                    {marketName}
                                </RabItemsWrapperMarket>
                            </RabItemsWrapper>
                        );
                    })}
                </RabItems>
                <RabItemsWrapperOdds data-test='bb-referral-price'>Total odds: {priceLabel}</RabItemsWrapperOdds>
            </BetslipYouDecideRabItemsWrapper>

            <ReturnWrapper data-test='bb-referral-returns'>
                <BetslipYouDecideEventReturn>
                    <I18n
                        langKey='betslip.stake'
                        defaultText='Stake:'
                    />{' '}
                    <BetslipYouDecideReturn>{stakeDisplay}</BetslipYouDecideReturn>
                </BetslipYouDecideEventReturn>
                <BetslipYouDecideEventReturn>
                    <I18n
                        langKey='betslip.you-decide.returns'
                        defaultText='Returns:'
                    />{' '}
                    <BetslipYouDecideReturn>{potentialReturnsLabel}</BetslipYouDecideReturn>
                </BetslipYouDecideEventReturn>
            </ReturnWrapper>
        </BetslipYouDecideWrapper>
    );
});
